module.exports = __webpack_public_path__ + "img/12.205586b2.svg";